
















































import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { cookieService } from '@/service/cookie.service';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import { SchoolClassPromotion } from '@/models/school-class/school-class-promotion';
import { Header, HeadMenu } from '@/constants/constants';
import { StudentPromotionRequest } from '@/models/student/student-promotion-request';
import { DataList } from '@/models/core/data-list';
import { GEnum } from '@/constants/enum.defination';
import { GPageBase } from '@/mixins';
import { studentModule } from '@/store/modules/entities/student.module';
import { BulkUpdateSchoolClassesRequest } from '@/models/school-class/school-class-bulk-update';

@Component({
  name: 'GLastStudentsEntryModal',
  computed: {},
  methods: {},
})
export default class GLastStudentsEntryModal extends Mixins(GPageBase) {
  showConfirmModal: boolean = false;
  schoolClassColumns: any[] = [];
  lastSchoolClasses: SchoolClass[] = [];
  notSelectedUsers: boolean = false;

  @Prop({ default: false }) value: boolean;
  @Watch('value')
  openModal(value: boolean) {
    this.showConfirmModal = value;
  }

  async mounted() {
    this.schoolClassColumns = [
      {
        title: this.$t('LAST_STUDENT_MODAL_COL_1').toString(),
        slot: 'action',
        width: 100,
        align: 'center',
      },
      {
        title: this.$t('LAST_STUDENT_MODAL_COL_3', {value: cookieService.schoolYearInt - 1}).toString(),
        slot: 'lastGradeAndSchoolClass',
        align: 'left',
      },
      {
        title: this.$t('LAST_STUDENT_MODAL_COL_4', {value: cookieService.schoolYear}).toString(),
        slot: 'newGradeAndSchoolClass',
        align: 'left',
      },
    ];

    // 昨年度のクラスを取得
    await schoolClassModule.fetchSchoolClasses({ [Header.SchoolYear]: cookieService.schoolYearInt - 1 }).then((response: SchoolClass[]) => {
      this.lastSchoolClasses = response.map((schoolClass: SchoolClass) => new SchoolClass().deserialize(schoolClass));
    });

    // 新年度のクラスを取得
    await schoolClassModule.fetchSchoolClasses();

    // 仮りの「新年度クラス」を作成する
    // 昨年度のクラス（学年 - クラス）の学年について +1 する（新年度のクラスにしてしまう）
    // この際、max は考慮しない
    const tmpNewClasses = this.lastSchoolClasses.map((schoolClass: SchoolClass) => {
      const tmpSchoolClass = new SchoolClass().deserialize(schoolClass)
      // 学年を1つ上げる
      tmpSchoolClass.grade++;
      return tmpSchoolClass;
    });

    // 上記で作成した仮りの新年度クラスを保持する
    schoolClassModule.setSchoolClasses(tmpNewClasses);

    schoolClassModule.fetchGradesSchoolClasses({ [Header.SchoolYear]: cookieService.schoolYearInt - 1 }).then(() => {
      const newGradeSchoolClasses: GradeSchoolClass[] = this.gradeSchoolClasses.map((gradeSchoolClass: GradeSchoolClass) => {
        gradeSchoolClass.schoolClasses.forEach((schoolClass: SchoolClass) => {
          // 新規作成フラグ（既存のクラスの学年を1つ上げたものを新規クラスとして作成する）
          schoolClass.created = true;
        });
        return gradeSchoolClass;
      });
      schoolClassModule.setGradeSchoolClasses(newGradeSchoolClasses);
    });

    console.log(this.schoolClassPromotions)
  }

  get prevYear(): number {
    return cookieService.schoolYearInt - 1;
  }

  get nextYear(): number {
    return cookieService.schoolYearInt;
  }

  get gradeSchoolClasses(): GradeSchoolClass[] {
    return schoolClassModule.gradeSchoolClasses;
  }

  // 進級対象クラスを計算
  // 仕様
  // - 進級後の最高学年までを進級対象とする(ex.3学年制では3年は進級対象から外す)
  // - クラス名が一致したものを進級後クラスとする(ex.旧学年2年1組→新学年3年1組)
  // - 進級対象でクラス名が一致しないものは新学年のいずれかのクラスにランダムに割り当てる
  // - 進級対象で進級後の学年が存在しない場合は進級不可能とする(ex.6学年制で4年が新学年で存在しないような場合)
  get schoolClassPromotions(): SchoolClassPromotion[] {
    let schoolClassPromotions: SchoolClassPromotion[] = [];
    const oldAssignedSchoolClass: Set<string> = new Set<string>();
    const newAssignedSchoolClass: Set<string> = new Set<string>();

    // クラス名が一致したものと進級対象外のものをまず求める
    schoolClassPromotions = this.lastSchoolClasses.reduce((result: SchoolClassPromotion[], schoolClass: SchoolClass) => {
      let tempSchoolClass: SchoolClass = new SchoolClass().deserialize(schoolClass);
      let newSchoolClass: SchoolClass;

      tempSchoolClass.grade = schoolClass.grade + 1; // 一旦新年度の学年に合わせる
      if (this.schoolClassGradeAndClassNameMap.has(tempSchoolClass.gradeAndSchoolClassName)) {
        // 進級後の学年内で同じクラス名が見つかった場合
        oldAssignedSchoolClass.add(schoolClass.gradeAndSchoolClassName);
        newAssignedSchoolClass.add(tempSchoolClass.gradeAndSchoolClassName);
        newSchoolClass = new SchoolClass().deserialize(this.schoolClassGradeAndClassNameMap.get(tempSchoolClass.gradeAndSchoolClassName));
        result.push(
          new SchoolClassPromotion().deserialize({
            oldSchoolClass: schoolClass,
            newSchoolClass: newSchoolClass,
            note: this.$t('LAST_STUDENT_MODAL_SCHOOL_CLASS_PROMOTION_1').toString(),
            canPromotion: true,
            selected: false,
          })
        );
      } else if (schoolClassModule.maxGrade <= schoolClass.grade) {
        // 新年度の最高学年が前年度の学年以上だった場合は進級対象から除外する
        oldAssignedSchoolClass.add(schoolClass.gradeAndSchoolClassName);
      }
      return result;
    }, []);

    // 進級対象でクラス名が一致しなかったものの進級先を決定し、追加する
    schoolClassPromotions = schoolClassPromotions.concat(
      this.lastSchoolClasses.reduce((result: SchoolClassPromotion[], lastSchoolClass: SchoolClass) => {
        let newSchoolClass: SchoolClass;

        if (oldAssignedSchoolClass.has(lastSchoolClass.gradeAndSchoolClassName)) {
          // すでに割り当て済み、または、進級対象外
          return result;
        }

        // 新年度クラス内で同学年の未割り当てのクラスを一つ抽出する
        const newSchoolClassIndex: number = this.schoolClasses.findIndex((newSchoolClass: SchoolClass) => {
          if (newAssignedSchoolClass.has(newSchoolClass.gradeAndSchoolClassName)) {
            // すでに新年度のクラスで割り当て済み
            return false;
          }
          if (newSchoolClass.grade !== lastSchoolClass.grade + 1) {
            // 同学年でない場合
            return false;
          }
          newAssignedSchoolClass.add(newSchoolClass.gradeAndSchoolClassName);
          return true;
        });

        if (newSchoolClassIndex < 0) {
          // 未割り当ての新年度クラスが存在しない場合
          // 同学年のすでに割り当て済みのクラスの中にランダムで仕方なく割り当てる
          const schoolClassesOfSameGrade = this.schoolClasses.filter((schoolClass: SchoolClass) => schoolClass.grade === lastSchoolClass.grade + 1);

          if (schoolClassesOfSameGrade.length == 0) {
            // 進級後の学年が存在しない場合
            result.push(
              new SchoolClassPromotion().deserialize({
                oldSchoolClass: lastSchoolClass,
                newSchoolClass: new SchoolClass(),
                note: this.$t('LAST_STUDENT_MODAL_SCHOOL_CLASS_PROMOTION_2').toString(),
                canPromotion: false,
                selected: false,
              })
            );
            return result;
          }

          newSchoolClass = new SchoolClass().deserialize(schoolClassesOfSameGrade[Math.floor(Math.random() * (schoolClassesOfSameGrade.length - 1))]);
        } else {
          // 割り当て対象が見つかった場合はそれを割り当てる
          newSchoolClass = new SchoolClass().deserialize(this.schoolClasses[newSchoolClassIndex]);
        }

        result.push(
          new SchoolClassPromotion().deserialize({
            oldSchoolClass: lastSchoolClass,
            newSchoolClass: newSchoolClass,
            note: this.$t('LAST_STUDENT_MODAL_SCHOOL_CLASS_PROMOTION_3').toString(),
            canPromotion: true,
            selected: true,
          })
        );

        return result;
      }, [])
    );

    // 学年,クラス名順に昇順
    return schoolClassPromotions.sort((a: SchoolClassPromotion, b: SchoolClassPromotion): number => {
      if (a.oldSchoolClass !== undefined && b.oldSchoolClass !== undefined && a.oldSchoolClass.grade < b.oldSchoolClass.grade) {
        return -1;
      }
      return 1;
    });
  }

  get schoolClassGradeAndClassNameMap(): Map<string, SchoolClass> {
    return schoolClassModule.schoolClassGradeAndClassNameMap;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses;
  }

  handleTogglePromotion(value: boolean, index: number) {
    this.schoolClassPromotions[index].selected = value;
    const count = this.schoolClassPromotions.filter((scp: SchoolClassPromotion) => scp.selected === true).length;
    if (count === 0) {
      this.notSelectedUsers = true;
    } else {
      this.notSelectedUsers = false;
    }
  }

  handleCancel() {
    this.$emit('input', false);
  }

  handleUpdate() {
    // 進級可能でかつ、進級有無がONのクラスセット
    const selectedSchoolClassPromotions = this.schoolClassPromotions
      .filter((schoolClassPromotion: SchoolClassPromotion) => schoolClassPromotion.newSchoolClass.schoolClassID !== undefined && schoolClassPromotion.selected)
      .map((schoolClassPromotion: SchoolClassPromotion) => {
        return new StudentPromotionRequest().deserialize({
          oldSchoolClassID: schoolClassPromotion.oldSchoolClass.schoolClassID,
          newSchoolClassID: schoolClassPromotion.newSchoolClass.schoolClassID,
        } as StudentPromotionRequest);
      });

    let studentPromotionRequest: DataList<StudentPromotionRequest> = {
      data: selectedSchoolClassPromotions,
    };

    this.isRunning = true;
    studentModule.promoteStudents(studentPromotionRequest).then(() => {
      this.isRunning = false;
      this.showNotice(GEnum.MessageType.Success, this.$t('NOTICE_COMPLETE_PROMOTE').toString(), this.$t('NOTICE_DONE_LAST_STUDENT_MODAL', {value: selectedSchoolClassPromotions.length}).toString(), 10);
      this.$emit('input', false);
      this.lazyAction(() => {
        this.isRunning = false;
        window.location.reload();
      }, 3000);
    });
  }

  get flattenSchoolClasses(): SchoolClass[] {
    return schoolClassModule.flattenSchoolClasses;
  }

  // 鍼灸処理（2026-02-18）
  // クラス設定や先生設定の操作を無くし、現在存在する「今年度のクラス」を自動で「新年度のクラス」として作成してから生徒を更新する
  async handleUpdate2() {
    const newClasses: SchoolClass[] = this.schoolClassPromotions.filter((scp: SchoolClassPromotion) => scp.selected)
    .map((scp: SchoolClassPromotion) => {
      if (scp.selected) return scp.newSchoolClass;
    });

    // クラス一括更新（ここでは自動的に行う新規作成のみ）
    await schoolClassModule.bulkUpdateSchoolClasses({
      updateSchoolClasses: [],
      addSchoolClasses: newClasses,
      deleteSchoolClassIDs: [],
    } as BulkUpdateSchoolClassesRequest);

    // ↑新規登録した新年度のクラスを再取得
    await schoolClassModule.fetchSchoolClasses();

    // 進級可能でかつ、進級有無がONのクラスセット
    const selectedSchoolClassPromotions = newClasses.filter((sc: SchoolClass) => {
      const grageClass = `${sc.grade}-${sc.schoolClassName}`;
      const newClass = schoolClassModule.schoolClassGradeAndClassNameMap.get(grageClass);
      if (newClass) return sc;
    }).map((sc: SchoolClass) => {
      const grageClass = `${sc.grade}-${sc.schoolClassName}`;
      const newClass = schoolClassModule.schoolClassGradeAndClassNameMap.get(grageClass);
      return new StudentPromotionRequest().deserialize({
        oldSchoolClassID: sc.schoolClassID,
        newSchoolClassID: newClass.schoolClassID,
      } as StudentPromotionRequest);
    });

    let studentPromotionRequest: DataList<StudentPromotionRequest> = {
      data: selectedSchoolClassPromotions,
    };
    //return;

    this.isRunning = true;
    studentModule.promoteStudents(studentPromotionRequest).then(() => {
      this.isRunning = false;
      this.showNotice(GEnum.MessageType.Success, this.$t('NOTICE_COMPLETE_PROMOTE').toString(), this.$t('NOTICE_DONE_LAST_STUDENT_MODAL', {value: selectedSchoolClassPromotions.length}).toString(), 10);
      this.$emit('input', false);
      this.lazyAction(() => {
        this.isRunning = false;
        this.$emit('handlePromotionComplete');
      }, 1000);
    });
  }

}
